import { IoMdSwap } from "react-icons/io";

import ArrowDownSMIcon from "assets/icons/ArrowDownSMIcon";

export function Swap() {
  return (
    <div className="z-2 relative">
      <div
        className="absolute -top-19 left-1/2 flex size-32 -translate-x-1/2
                   cursor-default select-none items-center justify-center rounded-full
                   border border-solid border-gray-light bg-gray-neutral"
      >
        <ArrowDownSMIcon className="h-24 w-24 text-white-alpha-60" />
      </div>
    </div>
  );
}
